import React, { Component } from 'react';
import { Timeline, Card, Image } from 'antd';
import Header from './common/Header';

class Home extends Component {
  renderAboutUs = () => {
    return (
      <>
        <Header title='About us' />
        <Timeline className='about-us'>
        <Timeline.Item>It is a sample phonebook application.</Timeline.Item>
        <Timeline.Item>It is developed using react.js and firebase.</Timeline.Item>
        <Timeline.Item>We can add user details and view it.</Timeline.Item>
      </Timeline>
      </>
    );
  }

  renderAddress = () => {
    return (
      <>
        <Header title='Address' />
        <code>
          E-PHONEBOOK<br/>
          XYZ HOME  - 2<br/>
          ABC STREET - 1<br/>
          SAMPLE STATE - 3<br/>
        </code>
      </>
    );
  }

  renderLogo = () => {
    return (
      <div className='logo'>
        <Image
          width={250}
          src={'https://img2.pngio.com/notebook-transparent-pen-notebook-with-pen-png-png-download-notepad-and-pen-png-860_659.png'}
          preview={false}
        />
      </div>
    );
  }

  render() {
    return (
      <Card style={{ margin: '25px' }} >
        {this.renderLogo()}
        {this.renderAboutUs()}
        {this.renderAddress()}
      </Card>
    );
  }
}
 
export default Home;